// components/PingPostView.tsx
'use client';

import { useEffect } from 'react';

export function PingPostView({ postId }: { postId: string }) {
  useEffect(() => {
    (async () => {
      const reg = await navigator.serviceWorker?.ready.catch(() => null);
      if (!reg) return;

      const sub = await reg.pushManager.getSubscription().catch(() => null);
      if (!sub) return;

      await fetch('/api/push/ping', {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          endpoint: sub.endpoint,
          language: document.documentElement.lang ?? '',
          posts: postId,
        }),
      });
    })();
  }, [postId]);

  return null;
}